import React, { useState } from 'react'
import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'
import SmartToyOutlinedIcon from '@mui/icons-material/SmartToyOutlined'
import { useApplicationSuiteContext } from '../../contexts/ApplicationSuiteProvider'
import LaunchAgentDialog from './LaunchAgentDialog'

interface RunAgentSessionButtonProps {
  backtest: any
}

function RunAgentSessionButton({ backtest }: RunAgentSessionButtonProps) {
  const { usermeta } = useApplicationSuiteContext()
  const [dialogOpen, setDialogOpen] = useState(false)

  if (!usermeta?.isAdmin) return null

  return (
    <>
      <Tooltip title="Run agent session from this backtest" placement="top">
        <IconButton size="small" onClick={() => setDialogOpen(true)}>
          <SmartToyOutlinedIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <LaunchAgentDialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        backtest={backtest}
      />
    </>
  )
}

export default RunAgentSessionButton
